// Toplu (konsolide) Toplama Ekranı (el terminali) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'wms.pickingConsolidated';

export const wmsPickingConsolidatedGuide = (t: TFunction): GuideContent => ({
  layout: 'stacked',
  title: t(`${G}.title`, 'Toplu toplama nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Çoklu iş emrinde aynı ürün birden fazla siparişte geçiyorsa ürünü tek seferde, toplam miktarıyla toplarsınız. Toplanan adet siparişlere otomatik paylaştırılır; fiziksel ayırma sonraki raflama adımında yapılır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'İlerleme, Konsolide, sepet'),
    form: t(`${G}.regions.form`, 'Toplanacak Ürün ve sipariş dağılımı'),
    list: t(`${G}.regions.list`, 'Okutma adımları'),
    footer: t(`${G}.regions.footer`, 'Atla / Stok Sorunu / Siparişi İptal Et'),
  },
  steps: [
    {
      region: 'form',
      title: t(`${G}.s1.title`, '1. Toplu listeyi okuyun'),
      text: t(`${G}.s1.text`, '"Toplanacak Ürün (Konsolide)" kartı ürünü, lokasyonunu, "Toplam … adet" ve "… siparişe dağıtılacak" bilgisini gösterir. Altındaki "Sipariş dağılımı" hangi siparişe kaç adet gideceğini listeler. Rota seçenekleri ve harita tekli toplamadaki gibidir.'),
    },
    {
      region: 'list',
      title: t(`${G}.s2.title`, '2. Lokasyonu ve ürünü okutun'),
      text: t(`${G}.s2.text`, 'Önce raftaki lokasyon barkodunu, sonra ürün barkodunu okutun. "Adım 3: Toplam Miktarı Onaylayın" kısmında kalan toplam adedi girip onaylayın. Ürünün stoğu olan başka bir raf okutulursa o raf da kabul edilir.'),
    },
    {
      region: 'form',
      title: t(`${G}.s3.title`, '3. Siparişlere dağıtım ve stok'),
      text: t(`${G}.s3.text`, 'Onayladığınız adet okuttuğunuz rafın stoğundan düşülür, stok hareketi yazılır ve siparişlere en eski siparişten başlayarak sırayla paylaştırılır. Tam karşılanan sipariş kalemi toplandı olur.'),
      tips: [
        t(`${G}.s3.tip1`, 'Raftaki stok yetmezse yalnız raftaki kadar toplanır ve "Lokasyonda yeterli stok yok. … adet toplandı, … adet eksik." uyarısı çıkar. Eksik kalan kalemler açık kalır; yerinde mal kabul veya stok sorunu ile kapatın.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Stok sorunu'),
      text: t(`${G}.s4.text`, '"Stok Sorunu" penceresinde kalan gerekli adet yazar. Seçenekler:'),
      tips: [
        t(`${G}.s4.tip1`, 'Yerinde mal kabul (lokasyona stok gir): girilen stok ürünün lokasyonuna eklenir, ardından kalan miktar otomatik toplanır ("Stok Gir ve Topla"). Ürünün tanımlı lokasyonu yoksa önce lokasyon atayın.'),
        t(`${G}.s4.tip2`, 'Kısmi topla, kalanı stok yok: bulduğunuz adet raftan düşülüp siparişlere dağıtılır; karşılanamayan kalemler eksik (short pick) olarak kapanır.'),
        t(`${G}.s4.tip3`, 'Tümü stok yok (istisna bırak): ürünün kalan kalemlerinin hepsi eksik olarak kapanır, stok değişmez.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Sipariş iptali ve bitirme'),
      text: t(`${G}.s5.text`, '"Siparişi İptal Et" önce bu üründen pay alan siparişleri listeler; iptal edilecek siparişi seçip sebebini girin. Sipariş İptal Yönetimi kuyruğuna düşer, ondan toplanmış ürünler stoğa geri eklenir ve diğer siparişlerle devam edilir. Tüm ürünler toplanınca iş emri raflama (siparişlere ayırma) adımına geçer.'),
      tips: [
        t(`${G}.s5.tip1`, 'Liste yüklenemezse "Tekrar Dene" ile yeniden deneyin; bağlantı kaynaklı geçici bir sorun olabilir.'),
      ],
    },
  ],
});
